import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";

export default class Currency extends Model {
    static entity = 'currencies';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'iso',
    };

    static fields() {
        return {
            id: this.uid(),
            iso: this.string(''),
            character: this.string(null).nullable(),
            name: this.string(null).nullable(),
            is_primary: this.boolean(false),

            created_at: this.string(''),
            updated_at: this.string(''),
        }
    }

    declare id: number;
    declare iso: string;
    declare character: string | null;
    declare name: string | null;
    declare is_primary: boolean;
    declare title: string | null;
}
